module.exports = __webpack_public_path__ + "img/semitrailerFrontLeftOutline.cf39f16c.svg";